import {
  LookupOptionItem,
  OnSelectData,
} from '../../ui-components/lib/lookup-field/lookup-field-item';
import { LookupResource } from '../../ui-components/lib/lookup-field/lookup-resource.model';
import { OptionItem } from '../../ui-components/lib/option.interface';
import { Option } from '../../core/common/models/option.model';
import { AttachmentTypeEnum } from '../../ui-components/lib/upload-files/attachment-type.enum';

export interface RequestFromBuilderResponse {
  data: Data;
}

export interface Data {
  sections: RequestFormGroup[];
  actions: Action[];
  cancel_button: CancelButton;
}

export interface CreateActionExtraData {
  template_id: number;
}

export interface CreateAction {
  type: string;
  extra_data?: CreateActionExtraData | null;
}

export type TriggerAction = CreateAction;

export interface RequestFormGroup {
  name: string;
  fields: Field[];
  show_condition?: string | null;
  updated_field_keys?: string[];
}

export interface Field {
  type: string;
  key: string;
  label: string;
  value: any;
  step: Step;
  section: Option;
  properties: PropertiesInterface;
  can_edit: boolean;
  can_answered: boolean;
  is_required: boolean;
  merge_with?: string | null;
  show_condition?: string | null;
  disable_condition?: string | null;
  is_hidden?: boolean;
  tooltip?: string | null;
  /** Used with create_action when opening a child workflow from this field. */
  parent_field_key?: string | null;
  multiple: {
    min_size: number;
    max_size: number;
  } | null;
  group?: {
    label: string;
    value: string;
    validation_rules: string[];
  };
  fields?: Field[];
}

export interface PropertiesInterface {
  placeholder: string;
  options?: any;
  equation?: string;
  relation_details: LookupOptionItem | OptionItem | any;
  relation_resource?: LookupResource | null;
  on_select_data?: OnSelectData[] | OnSelectData | null;
  /** Child-workflow CTA returned by form-sections on multi-lookup fields. */
  create_action?: CreateAction | null;
  extensions: string;
  max_file_size: number;
  attachment_type?: AttachmentTypeEnum;
  country?: string;
  national_number?: string;
  max_decimal_places?: number;
  min_decimal_places?: number;
  updated_field_key?: string;
  min?: number;
  max?: number;
  current_length?: number;
  on_load_data?: OnSelectData;
  max_length?: number;
  dependency_fields?: string[];
  can_maintain_items?: boolean;
  formatType?: string;
}

export enum Step {
  Default = 'default',
}

export interface Action {
  value: string;
  label: string;
  color: string;
  group?: {
    value: string;
    label: string;
  };
}

export interface CancelButton {
  label: string;
  color: string;
}
